<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    />
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

// Parse and validate configuration using fail-fast Zod validation
const baseConfig = parseAndValidateConverterConfig('pict-to-tiff-converter', 'PICT → TIFF');

// Merge base config with PICT→JPG specific labels
const converterConfig = {
  ...baseConfig,
  jobCategory: 'image.pict-to-tiff',
  labels: {
    dropzoneHeading: 'Drop PICT Files Here',
    emptyQueueMessage: 'Drop PICT files to start your first conversion.',
    statsLabel: 'Median PICT → TIFF time (last 10k jobs): {p50TimeMs}',
    batchCompleteTitle: 'All {n} files converted successfully!',
    batchInProgressTitle: 'Converting {n} files...',
  },
  supportUrl: '/contact',
  pricingUrl: '/pricing',
};

// Event handlers
function handleBatchCreated(batchId: string) {
  console.log('[PICT to TIFF Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[PICT to TIFF Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[PICT to TIFF Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[PICT to TIFF Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[PICT to TIFF Converter] Credits updated:', credits);
}
</script>
